import api from "@/services/api";

const _http = {
  async getAll(params = {}) {
    try {
      const response = await api.get("/parameter", {
        params,
      });

      return response;
    } catch (error) {
      console.error(
        "Parameter Service Error:",
        error.response?.data || error.message,
      );

      throw error;
    }
  },
  async create(data) {
    return api.post("/parameter", data);
  },
  async update(id, data) {
    return api.put(`/parameter/${id}`, data);
  },

  async updateStatus(id, is_active) {
    return api.put(`/parameter/${id}/status`, { is_active });
  },
};




export default {
  async getAll(query = {}) {
    try {
      const res = await _http.getAll(query);
      return {
        data: res.data.data.data.map((item) => item),
        total: res.data.data.total || 0,
      };
    } catch (error) {
      console.error(error);
      return {
        data: [],
        total: 0,
      };
    }
  },

  async create(payload) {
    try {
      const response = await _http.create(payload);
      return response.data;
    } catch (error) {
      console.error("Error creating parameter:", error);
      throw error;
    }
  },

  async update(id, payload) {
    try {
      const response = await _http.update(id, payload);
      return response.data;
    } catch (error) {
      console.error("Error updating parameter:", error);
      throw error;
    }
  },

  async updateStatus(id, is_active) {
    try {
      const response = await _http.updateStatus(id, is_active);

      return response.data;
    } catch (error) {
      console.error(error);

      return {
        success: false,
        message: error.message,
      };
    }
  },
};

